// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.List_addTableFeatureContainer__R\\+zQR {
  width: 250px;
  height: 50px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0080ff;
  color: #fff;
  fill: #fff;
  border-radius: 7px;
  margin-right: 40px;
  transform: translateY(-190px);
}`, "",{"version":3,"sources":["webpack://./src/pages/MLM/StepStairCommission/List.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B","sourcesContent":[".addTableFeatureContainer {\r\n  width: 250px;\r\n  height: 50px;\r\n  position: relative;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #0080ff;\r\n  color: #fff;\r\n  fill: #fff;\r\n  border-radius: 7px;\r\n  margin-right: 40px;\r\n  transform: translateY(-190px);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addTableFeatureContainer": `List_addTableFeatureContainer__R+zQR`
};
export default ___CSS_LOADER_EXPORT___;
